export const PANEL_HEIGHT = 400;
export const LARGE_PANEL_HEIGHT = 750;
